
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'color',
        field: 'cor',
        label: 'Cor das Colunas',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'boolean',
        field: 'ativo',
        label: 'Tabela Ativo?',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'copiar',
        label: 'Copiar Versão',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: 'Caso desejar copiar um modelo de tabela já cadastrado, selecione aqui a tabela para ser copiada.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        info: '',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/tabela-dinamica/_form/tabela-cadastrar.js